import { render, staticRenderFns } from "./ValidationCreate.vue?vue&type=template&id=6a6474e4&scoped=true&"
import script from "./ValidationCreate.vue?vue&type=script&lang=js&"
export * from "./ValidationCreate.vue?vue&type=script&lang=js&"
import style0 from "./ValidationCreate.vue?vue&type=style&index=0&id=6a6474e4&prod&scoped=true&lang=css&"
import style1 from "./ValidationCreate.vue?vue&type=style&index=1&id=6a6474e4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6474e4",
  null
  
)

export default component.exports